export const API_EXTERNAL_ENDPOINT = 'bookmarks/save'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/bookmarks/save'
